import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ConstOperatorParameters} from "#template/nodes/geometry-graph/attribute/const-operator/geometry-const-operator-node"
import {GeometryConstOperatorNode, constOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/const-operator/geometry-const-operator-node"

export type CurveGeometryConstOperatorParameters = ConstOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryConstOperatorParameters> = {
    nodeClass: "CurveGeometryConstOperator",
    validation: {
        parameters: constOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryConstOperator extends GeometryConstOperatorNode<1, CurveGeometryAttributeLikeNode> implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
